import axios, { type AxiosInstance } from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8080';

export const apiClient: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

export async function apiFetch<T>(
  path: string,
  init?: { method?: string; body?: unknown },
): Promise<T> {
  const res = await apiClient.request<T>({
    url: path,
    method: init?.method ?? 'GET',
    data: init?.body,
  });
  return res.data;
}

/** Absolute URL for an uploaded file served by GET /api/files/<storedPath>. */
export function fileUrl(storedPath: string): string {
  return `${baseURL.replace(/\/$/, '')}/api/files/${storedPath}`;
}
